import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Dialog } from '@independent-software/typeui/controls/Dialog';
import { Loader } from '@independent-software/typeui/controls/Loader';
import { Icon } from '@independent-software/typeui/controls/Icon';
import { ToastService } from '@independent-software/typeui/controls/Toast';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { SampleForm } from './SampleForm';
import { SampleFactory, Sample } from '../../resource/';

type TStep = 'ready' | 'saving' | 'saveError';

const AddSample = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();
  
  const sample = React.useRef(SampleFactory.create());
  const [step, setStep] = React.useState('ready' as TStep);
  const [valid, setValid] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [formData, setFormData] = React.useState(sample.current);
  const [dirty, setDirty] = React.useState(false);

  const handleChange = (data: Sample, forceupdate: boolean) => {
    sample.current = Object.assign(sample.current, data);
    if(forceupdate) setFormData({...data});
  }

  const handleValidate = (_valid: boolean) => setValid(_valid);

  const handleSubmit = () => {
    setFormData(sample.current);
    setDirty(true);
    if(!valid) return;    
    setError(null);
    setStep('saving');

    sample.current.$save(auth)
    .then(_ => {
      ToastService.toast("Sample created.");
      navigate("/samples");
    })
    .catch(error => {
      setStep('saveError');
      setError(error);
    });
  }

  const handleCancelSave = () => setStep('ready');

  return (
    <Container>
      {step == 'saving' && <Loader></Loader>}
      <React.Fragment>
        <Content>
          <SampleForm dirty={dirty} data={formData} onChange={handleChange}  onValidate={handleValidate}/>
        </Content>
        <BottomBar>
          <Button primary disabled={!valid} onClick={handleSubmit}><Icon name="save"/> Save</Button>
          <Button secondary onClick={() => navigate(-1)}>Cancel</Button>
        </BottomBar>
      </React.Fragment>
      <Dialog.Xhr open={step == 'saveError'} error={error} onClose={handleCancelSave} onRetry={handleSubmit}/>
    </Container>
  )
}

export { AddSample }
